import React, { useState } from "react";
import PropTypes from "prop-types";
import PopupPortal from "../../shared/common/PopupWindow";
import LoginForm from "../Forms/LoginForm";
import ResetPasswordForm from "../Forms/ResetPassForm";
import { isResetWithActivation } from "../Config";
import ResetPassCodeWrapper from "./ResetPassCodeWrapper";

const LoginResetPopup = ({ buttonClass, buttonText }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoginMode, setIsLoginMode] = useState(true);

  const closePopup = () => {
    setIsLoginMode(true);
    setIsOpen(false);
  };

  const toggleReset = () => {
    setIsLoginMode(!isLoginMode);
  };

  return (
    <>
      <button type="button" onClick={() => setIsOpen(true)} className={buttonClass}>{buttonText}</button>
      <PopupPortal open={isOpen} onClose={() => closePopup()}>
        {isLoginMode ?
          <LoginForm toggleReset={toggleReset}/>
          : <>
            {isResetWithActivation ? <ResetPassCodeWrapper/> : <ResetPasswordForm/>}
          </>
        }
      </PopupPortal>
    </>
  );
};

export default LoginResetPopup;

LoginResetPopup.defaultProps = {
  buttonClass: "login-button",
  buttonText: "ลงชื่อเข้าใช้",
};

LoginResetPopup.propTypes = {
  buttonClass: PropTypes.string,
  buttonText: PropTypes.string,
};
